import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';

import {sortRating} from '@/shared/utils/users';
import {RatingMeItem} from './RatingMeItem';
import {RatingItem} from './RatingItem';
import {useStore} from '@/app/providers/StoreProvider';
import {Virtuoso, ListRange} from "react-virtuoso";
import {Loading} from "@/shared/ui/Loading";
import {observer} from "mobx-react-lite";


export const RatingList = observer(() => {
    const {userStore, ratingStore} = useStore();
    const {rating, loading} = ratingStore;
    const {user,gameInfo} = userStore;


    const myId = user.id;
    console.log(user.score);
    const { usersSort, myPlace } = useMemo(() => {
        const sorted = sortRating(rating);

        let index = -1;
        for (let i = 0; i < sorted.length; i++) {
            if (sorted[i].user.id === user.id) {
                index = i;
                break;
            }
        }
        return { usersSort: sorted, myPlace: index };
    }, [rating, user.id, user.score]);

    const [visibleRange, setVisibleRange] = useState({
        start: 0,
        end: 0
    });
    const firstRangeSkipped = useRef(false);



    const handleRange = (range: ListRange) => {
        if (!firstRangeSkipped.current) {
            firstRangeSkipped.current = true;
            return;
        }
        setVisibleRange({start: range.startIndex, end: range.endIndex});
    };

    const isMeVisible =
        myPlace !== -1 &&
        myPlace >= visibleRange.start &&
        myPlace <= visibleRange.end;

    const itemContent = useCallback((index: number) => {
        const item = usersSort[index];
        return item.user.id !== myId
            ? <RatingItem place={index + 1} user={item.user}/>
            : <RatingMeItem place={myPlace + 1} user={user}/>;
    }, [usersSort, myId, myPlace, user]);


    if (loading) return <Loading/>;
    return (
        <div
            className="rating-list"
            style={{
                height: window.Telegram?.WebApp?.viewportStableHeight ?? "100%",
                position: "relative",
            }}
        >
            <Virtuoso
                style={{height: "100%"}}
                totalCount={usersSort.length}
                rangeChanged={handleRange}
                useWindowScroll={false}
                components={{
                    Footer: () => (
                        <div style={{height: 50}}/>
                    )
                }}
                itemContent={itemContent}
            />

            {!isMeVisible && (
                <div
                    style={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        zIndex: 999,
                    }}
                >
                    <RatingMeItem place={myPlace + 1} user={user}/>
                </div>
            )}
        </div>
    );
});
